import React from 'react';
import {OPEN_SIDEBAR, CLOSE_SIDEBAR} from './sidebarTypes';
import {openMsg} from '../msg/msgActions';
import {dev} from 'lib.common';

export function closeSidebar() {
   return {
      type: CLOSE_SIDEBAR
   };
}

export function openSidebar(
   Component,
   componentProps = {},
   callbackOnClose = null,
   containerProps = {}
) {
   return async function (dispatch) {
      const {open, onClose, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               dispatch(closeSidebar());
            } else {
               dispatch(closeSidebar());
            }
         } catch (error) {
            dispatch(openMsg(dev.getErrorMsg(error)));
         }
      }
      dispatch({
         type: OPEN_SIDEBAR,
         payload: {
            ...options,
            onClose: handleCloseModalCallback,
            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={() => {
                     dispatch(closeSidebar());
                  }}
                  {...componentProps}
               />
            )
         }
      });
   };
}
